import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";
import SidebarNavMenu from "../../components/SidebarNavMenu";

import {ReactComponent as ArrowIcon} from "assets/img/arrow-3.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {canAccessEnrichment} from "utils/enrichmentAccess";

import {SidebarContext} from "../../../../../../SidebarContext";

function MerchandisingItem(props) {
    const {currentPath, currentMemberAuthorizations, currentOrganization} = useContext(SidebarContext);

    const hasMerchandisingAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_MERCHANDISING) &&
        (
            hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_PRODUCT_VIEW) || // Theses two authorizations are needed for accessing to the merchandising/products route
            hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_PRODUCT_MANAGEMENT)
        );
    const hasOrganizationManagementAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.GLOBAL_ORGANIZATION_MANAGEMENT);
    const hasCategoryManagementAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_CATEGORY_MANAGEMENT);
    const hasEnrichmentAccess = canAccessEnrichment(currentMemberAuthorizations, currentOrganization);

    if (
        !hasMerchandisingAuthorization
        && !hasOrganizationManagementAuthorization
        && !hasCategoryManagementAuthorization
        && !hasEnrichmentAccess
    ) {
        return null;
    }

    const isInMerchandisingPath = !!(
        currentPath.startsWith(MarketplaceRoutes.MERCHANDISING)
        || currentPath.startsWith(MarketplaceRoutes.CORNERS)
        || currentPath.startsWith(MarketplaceRoutes.RECOMMENDATIONS)
        || currentPath.startsWith(MarketplaceRoutes.ENRICHMENT)
    );

    return (
        <SidebarNavMenu
            open={isInMerchandisingPath}
            icon={<ArrowIcon />}
            content={<FormattedMessage id='sidebar.item.merchandising' />}
        >
            {hasMerchandisingAuthorization && (
                <SidebarItem
                    to={MarketplaceRoutes.MERCHANDISING}
                    selected={currentPath === MarketplaceRoutes.MERCHANDISING}
                >
                    <FormattedMessage id={'sidebar.item.merchandising.productList'} />
                </SidebarItem>
            )}
            {hasEnrichmentAccess && (
                <SidebarItem
                    to={MarketplaceRoutes.ENRICHMENT}
                    selected={currentPath === MarketplaceRoutes.ENRICHMENT}
                >
                    <FormattedMessage id={'sidebar.item.enrichment'} />
                </SidebarItem>
            )}
            {hasCategoryManagementAuthorization && (
                <SidebarItem
                    to={MarketplaceRoutes.CORNERS}
                    selected={currentPath === MarketplaceRoutes.CORNERS}
                >
                    <FormattedMessage id={'sidebar.item.corners'} />
                </SidebarItem>
            )}
            {hasOrganizationManagementAuthorization && (
                <SidebarItem
                    to={MarketplaceRoutes.RECOMMENDATIONS}
                    selected={currentPath === MarketplaceRoutes.RECOMMENDATIONS}
                >
                    <FormattedMessage id={'sidebar.item.recommendations'} />
                </SidebarItem>
            )}
        </SidebarNavMenu>
    );
}

export default MerchandisingItem;
